/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkCreateTimesheetEntriesTimesheetEntryData } from './BulkCreateTimesheetEntriesTimesheetEntryData';
import {
    BulkCreateTimesheetEntriesTimesheetEntryDataFromJSON,
    BulkCreateTimesheetEntriesTimesheetEntryDataFromJSONTyped,
    BulkCreateTimesheetEntriesTimesheetEntryDataToJSON,
    BulkCreateTimesheetEntriesTimesheetEntryDataToJSONTyped,
} from './BulkCreateTimesheetEntriesTimesheetEntryData';
import type { BulkCreateTimesheetEntryDataBaseTimesheetEntryData } from './BulkCreateTimesheetEntryDataBaseTimesheetEntryData';
import {
    BulkCreateTimesheetEntryDataBaseTimesheetEntryDataFromJSON,
    BulkCreateTimesheetEntryDataBaseTimesheetEntryDataFromJSONTyped,
    BulkCreateTimesheetEntryDataBaseTimesheetEntryDataToJSON,
    BulkCreateTimesheetEntryDataBaseTimesheetEntryDataToJSONTyped,
} from './BulkCreateTimesheetEntryDataBaseTimesheetEntryData';

/**
 * 
 * @export
 * @interface BulkCreateTimesheetEntryData
 */
export interface BulkCreateTimesheetEntryData {
    /**
     * 
     * @type {BulkCreateTimesheetEntryDataBaseTimesheetEntryData}
     * @memberof BulkCreateTimesheetEntryData
     */
    baseTimesheetEntryData: BulkCreateTimesheetEntryDataBaseTimesheetEntryData;
    /**
     * Each timesheet entry that needs to be created, with any overrides for that specific timesheet entry
     * @type {Array<BulkCreateTimesheetEntriesTimesheetEntryData>}
     * @memberof BulkCreateTimesheetEntryData
     */
    timesheetEntries: Array<BulkCreateTimesheetEntriesTimesheetEntryData>;
}

/**
 * Check if a given object implements the BulkCreateTimesheetEntryData interface.
 */
export function instanceOfBulkCreateTimesheetEntryData(value: object): value is BulkCreateTimesheetEntryData {
    if (!('baseTimesheetEntryData' in value) || value['baseTimesheetEntryData'] === undefined) return false;
    if (!('timesheetEntries' in value) || value['timesheetEntries'] === undefined) return false;
    return true;
}

export function BulkCreateTimesheetEntryDataFromJSON(json: any): BulkCreateTimesheetEntryData {
    return BulkCreateTimesheetEntryDataFromJSONTyped(json, false);
}

export function BulkCreateTimesheetEntryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateTimesheetEntryData {
    if (json == null) {
        return json;
    }
    return {
        
        'baseTimesheetEntryData': BulkCreateTimesheetEntryDataBaseTimesheetEntryDataFromJSON(json['baseTimesheetEntryData']),
        'timesheetEntries': ((json['timesheetEntries'] as Array<any>).map(BulkCreateTimesheetEntriesTimesheetEntryDataFromJSON)),
    };
}

  export function BulkCreateTimesheetEntryDataToJSON(json: any): BulkCreateTimesheetEntryData {
      return BulkCreateTimesheetEntryDataToJSONTyped(json, false);
  }

  export function BulkCreateTimesheetEntryDataToJSONTyped(value?: BulkCreateTimesheetEntryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseTimesheetEntryData': BulkCreateTimesheetEntryDataBaseTimesheetEntryDataToJSON(value['baseTimesheetEntryData']),
        'timesheetEntries': ((value['timesheetEntries'] as Array<any>).map(BulkCreateTimesheetEntriesTimesheetEntryDataToJSON)),
    };
}

